import { render, staticRenderFns } from "./text-editor-component.vue?vue&type=template&id=0e45321c&scoped=true"
import script from "./text-editor-component.vue?vue&type=script&setup=true&lang=ts"
export * from "./text-editor-component.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./text-editor-component.vue?vue&type=style&index=0&id=0e45321c&prod&scoped=true&lang=css"
import style1 from "./text-editor-component.vue?vue&type=style&index=1&id=0e45321c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e45321c",
  null
  
)

export default component.exports